import React, { memo, useCallback } from 'react';
import { filterOptionPropTypes } from 'core/propTypes/filterPropTypes';

const formatOptionValue = (value) => {
    return value.replace(/[-_]/g, ' ').toLowerCase().replace(/^\w/, char => char.toUpperCase());
};

const FilterOption = memo(({ option, onOptionChange, type }) => {
    const handleChange = useCallback((e) => {
        if (type === 'single' && option.checked) {
            onOptionChange(false);
        } else {
            onOptionChange(e.target.checked);
        }
    }, [option.checked, onOptionChange, type]);

    return (
        <li>
            <label className="checkbox-item w-100">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block' }}>
                    {formatOptionValue(option.value)}
                </span>
                <input
                    type={type === 'single' ? 'checkbox' : 'checkbox'}
                    checked={option.checked}
                    onChange={handleChange}
                    name={type === 'single' ? 'single-filter' : undefined}
                />
                <span className="checkmark" />
            </label>
        </li>
    );
});

FilterOption.propTypes = filterOptionPropTypes;

export default FilterOption;
